/* eslint-disable react/prop-types */
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from '@/helpers/utils';
 

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer,
  LegendComponent
]);

type SessionByBrowserItem = {
  label: string;
  count: number;
};

type PieDataItem = {
  name: string;
  value: number;
};

const getOptions = (data: PieDataItem[]) => ({
  textStyle: {
    fontFamily: 'dana'
  },
  color: [getColor('success'), getColor('warning'), getColor('danger')],
  tooltip: {
    trigger: 'item',
    padding: [7, 10],
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('gray-1100') },
    borderWidth: 1,
    transitionDuration: 0,
    formatter: (params: { data: { name: string }; percent: number }) =>
      `<div><strong>${params.data.name}:</strong> ${params.percent}%</div>`.toPersianDigit()
  },

  legend: { show: false },
  series: [
    {
      type: 'pie',
      radius: ['100%', '65%'],
      avoidLabelOverlap: false,
      itemStyle: {
        borderWidth: 2,
        borderColor: getColor('gray-100')
      },
      label: {
        show: false
      },
      emphasis: {
        scale: false
      },
      data
    }
  ]
});

const SessionByBrowserChart = ({ data }: { data: SessionByBrowserItem[] }) => {
  const formattedData = data.map(item => ({
    name: item.label,
    value: item.count
  }));
  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getOptions(formattedData)}
      style={{ height: 200 }}
    />
  );
};

export default SessionByBrowserChart;
